// extracted by mini-css-extract-plugin
module.exports = {"container":"LazyRender__container__LuF0H"};